module.exports = __webpack_public_path__ + "img/default_head.ec55bbf6.png";